export default __webpack_public_path__ + "media/ZoomMeeting.84155764.svg";